var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style["download-module"] }, [
    _c("div", { staticClass: "m-container" }, [
      _c("div", { class: _vm.$style["container-inner"] }, [
        _c(
          "div",
          {
            staticClass: "flex justify-center",
            class: _vm.$style["module-head"]
          },
          [
            _c("div", { class: _vm.$style["module-info"] }, [
              _c(
                "h2",
                {
                  staticClass: "enter-animate animate__fadeInUp",
                  class: _vm.$style["module-title"]
                },
                [
                  _c("span", { staticClass: "text" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("300248")) +
                        "\n                        "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "h3",
                {
                  staticClass: "enter-animate animate__fadeInUp",
                  class: _vm.$style["module-subtitle"]
                },
                [
                  _c("span", { staticClass: "text" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("300249")) +
                        "\n                        "
                    )
                  ])
                ]
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { class: _vm.$style["module-data"] }, [
          _c(
            "div",
            {
              staticClass: "enter-animate animate__fadeInUp",
              class: _vm.$style["app-market-list"]
            },
            [
              _c(
                "div",
                { staticClass: "relative", class: _vm.$style["item-wrapper"] },
                [
                  _c("div", { class: _vm.$style["list-item"] }, [
                    _c(
                      "div",
                      {
                        staticClass: "flex justify-center items-center",
                        class: _vm.$style["list-item--inner"],
                        on: {
                          click: function($event) {
                            return _vm.goLink(_vm.downloadUrl.appStore)
                          }
                        }
                      },
                      [
                        _c("svg-icon", {
                          class: _vm.$style["icon"],
                          attrs: { "icon-class": _vm.appMarketList[0].icon }
                        })
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { class: _vm.$style["item-wrapper"] }, [
                _c(
                  "a",
                  {
                    class: _vm.$style["list-item"],
                    attrs: { target: "_blank", href: _vm.appMarketList[1].link }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "flex justify-center items-center",
                        class: _vm.$style["list-item--inner"],
                        on: {
                          click: function($event) {
                            return _vm.goLink(_vm.downloadUrl.TFLink)
                          }
                        }
                      },
                      [
                        _c("svg-icon", {
                          class: _vm.$style["icon"],
                          attrs: { "icon-class": _vm.appMarketList[1].icon }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { class: _vm.$style["item-wrapper"] }, [
                _c("div", { class: _vm.$style["list-item"] }, [
                  _c(
                    "div",
                    {
                      staticClass: "flex justify-center items-center",
                      class: _vm.$style["list-item--inner"],
                      on: {
                        click: function($event) {
                          return _vm.goLink(_vm.downloadUrl.googlePlay)
                        }
                      }
                    },
                    [
                      _c("svg-icon", {
                        class: _vm.$style["icon"],
                        attrs: { "icon-class": _vm.appMarketList[2].icon }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { class: _vm.$style["item-wrapper"] }, [
                _c(
                  "a",
                  {
                    class: _vm.$style["list-item"],
                    attrs: { target: "_blank", href: _vm.appMarketList[3].link }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "flex justify-center items-center",
                        class: _vm.$style["list-item--inner"],
                        on: {
                          click: function($event) {
                            return _vm.goLink(_vm.downloadUrl.androidApk)
                          }
                        }
                      },
                      [
                        _c("svg-icon", {
                          class: _vm.$style["icon"],
                          attrs: { "icon-class": _vm.appMarketList[3].icon }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { class: _vm.$style["item-wrapper"] }, [
                _c(
                  "a",
                  {
                    class: _vm.$style["list-item"],
                    attrs: { "data-type": "more" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "flex justify-center items-center",
                        class: _vm.$style["list-item--inner"],
                        on: {
                          click: function($event) {
                            return _vm.$router.push("/downloadMore")
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "text" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.$t("300250")) +
                              "\n                                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("UeIcon", {
                          class: [
                            _vm.$style["ic"],
                            { mirrorRotateLevel: _vm.isDirection }
                          ],
                          attrs: { name: "long-arrow-right" }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { class: _vm.$style["app-thumb"] }, [
            _c("div", { class: _vm.$style["bg-layer-2"] }, [
              _c(
                "div",
                { ref: "orbContainer", class: _vm.$style["orb-container"] },
                [_c("canvas")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "enter-animate animate__fadeInLeft",
                class: _vm.$style["thumb--desktop"]
              },
              [
                _c("div", { class: _vm.$style["thumb--inner"] }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../assets/images/newImg/app-thumb-desktop.png"),
                      alt: ""
                    }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "enter-animate animate__fadeInRight",
                class: _vm.$style["thumb--mobile"]
              },
              [
                _c("div", { class: _vm.$style["thumb--inner"] }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../assets/images/newImg/app-thumb-mobile.png"),
                      alt: ""
                    }
                  })
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.$style["module-footer"] }, [
          _c(
            "div",
            {
              staticClass: "enter-animate animate__fadeInUp",
              class: _vm.$style["app-intro"]
            },
            [
              _c("span", { staticClass: "text" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("400002")) +
                    "\n                    "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex justify-center items-center relative",
              class: _vm.$style["btn-box"]
            },
            [
              _c("div", { class: _vm.$style["box-bg"] }),
              _vm._v(" "),
              !_vm.token
                ? _c(
                    "button",
                    {
                      staticClass:
                        "flex justify-center items-center enter-animate animate__fadeInUp",
                      class: _vm.$style["btn--register"],
                      on: {
                        click: function($event) {
                          return _vm.$router.push("/register")
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "text" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("300352")) +
                            "\n                        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("UeIcon", {
                        class: _vm.$style["ic"],
                        attrs: { name: "long-arrow-right" }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2111c8db", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2111c8db","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/newHome/index/DownloadModule.vue
// module id = Rt2a
// module chunks = 0